
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import TruckModule from "@/store/modules/truck";
import { TruckListItem } from "@/models/api/trucks/getTrucks";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

const truckModuleState = getModule(TruckModule);

import Papa from "papaparse";
import draggable from "vuedraggable";

import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { getTruckCubeWarningLevel } from "@/store/modules/truck/helpers";
import { formatDecimal } from "@/utils";

@Component({
  components: {
    RightClickMenu,
    draggable
  }
})
export default class TrucksTable extends Vue {
  @Prop({ default: "table" })
  public id: string;

  @Prop({ default: "" })
  public containerClass: string;

  @Prop({ default: null })
  public tableField: Array<any>;

  @Prop({ default: null })
  public tableMenuItem: Array<any>;

  public rightClickLocation: any = null;
  public showHelp: boolean = false;
  public currentSort: string = "DeliveryDate";
  public currentSortDir: string = "asc";
  public draggingData: boolean = false;
  public cubeWarningFields: Array<string> = ["availableCubes"];

  get filterFields() {
    let filterFields = this.tableField.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterFields(newValue) {
    this.$emit("updateFields", newValue);
  }

  get totalItems() {
    return truckModuleState.pageData.totalItems;
  }

  get trucks(): Array<TruckListItem> {
    return truckModuleState.data;
  }

  get totalMaxCubes(): number {
    return this.trucks.reduce((a, b) => a + (b['maxCubes'] || 0), 0)
  }

  get totalCubesUsed(): number {
    return this.trucks.reduce((a, b) => a + (b['cubesUsed'] || 0), 0)
  }

  get loading(): boolean {
    return truckModuleState.loading;
  }

  get selectedTruckCount(): number {
    return truckModuleState.getSelectedTruckCount;
  }

  get selectedTrucks(): Array<any> {
    return truckModuleState.getSelectedTrucks;
  }

  unselectAll() {
    let trucks = this.selectedTrucks;

    trucks.forEach(truck => {
      truckModuleState.switchTruckSelectionStatus(truck.id);
    });
  }

  getComponentData(rowData) {
    return {
      on: {
        click: () => this.onRowClick(rowData),
        contextmenu: $event => this.onRightClicked(rowData, $event),
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }
  canMove() {
    return false;
  }
  putFeature() {
    if (this.id === "truckTable") {
      return this.putTable;
    } else {
      return false;
    }
  }
  putTable(item, index, event) {
    this.draggingData = true;
  }
  sort(s) {}
  onRightClicked(rowData, event) {
    event.preventDefault();
    if (!rowData.selected) truckModuleState.switchTruckSelectionStatus(rowData.id);

    this.rightClickLocation = { x: event.x, y: event.y };
  }
  onDoubleClicked(truckData) {
    let truckNumber = truckData.id;
    this.$router.push(`/trucks/${truckNumber}`);
  }
  onRowClick(rowData) {
    truckModuleState.switchTruckSelectionStatus(rowData.id);

    this.clearRightClick();
  }
  clearRightClick() {
    this.rightClickLocation = null;
    this.draggingData = false;
  }
  clickMenu(item) {
    let trucks = this.selectedTrucks;
    this.$store.dispatch(item.action, { selectedItems: trucks });
    this.clearRightClick();
  }
  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (
      Math.ceil(scrollTop) + clientHeight >= scrollHeight &&
      !this.loading &&
      truckModuleState.pageData.totalItems > this.trucks.length
    ) {
      this.$emit("loadMoreData");
    }
  }

  getFieldClass(field, truckData) {
    var fieldClass = null;
    if (field.textAlign) {
      switch (field.textAlign) {
        case "right":
          fieldClass = "text-right";
          break;
        case "left":
          fieldClass = "text-left";
          break;
        case "center":
          fieldClass = "text-center";
          break;
        default:
          break;
      }
    }

    if (this.cubeWarningFields.findIndex(x => x == field.key) >= 0) {
      let warningLevel = getTruckCubeWarningLevel(truckData.cubesUsed, truckData.maxCubes);
      fieldClass = fieldClass + " truck-cube-warning-" + warningLevel.toString();
    }
    return fieldClass;
  }
}
